export const getDeclinedWord = (count) => {
  const forms = {
    one: 'помещения',
    two: 'помещений',
  };

  const numStr = String(count);

  if (
    numStr.length > 1 &&
    numStr[numStr.length - 1] === '1' &&
    ((numStr[numStr.length - 2] >= '2' && numStr[numStr.length - 2] <= '9') ||
      numStr[numStr.length - 2] === '0')
  ) {
    return `у ${count} ${forms.one}`;
  } else {
    return `у ${count} ${forms.two}`;
  }
};
